/**
 * Tegevuste haldamise store
 */
import _ from "underscore";
import alt from "../alt";
import PageActionActions from "./PageActionActions";
/**
 * @typedef {object} PageActionState
 * @property {PageAction} action
 */
/**
 * Action store class
 */
class PageActionStore {
    constructor() {
        /**
         * @type {PageActionState}
         */
        this.state = {
            action: null
        };
        this.bindActions(PageActionActions);
    }

    onCallAction(action) {
        this.setState({action: _.clone(action)});
    }
}

/**
 *
 * @type {AltJS.AltStore<PageActionState>|PageActionStore}
 */
let actionStore = alt.createStore(PageActionStore, "PageActionStore");
export default actionStore;
